import { mapState } from 'vuex';
import get from 'lodash/get';
import set from 'lodash/set';
import cloneDeep from 'lodash/cloneDeep';
import NestedDashboardOptionsEditor from '../nestedDashboardOptionsEditor.vue';
import TwinAttributesSelector from '../twinAttributesSelector.vue';
import twinFields from '../twinFields';
const {
  isServerSortableProperty
} = twinFields;
export default {
  name: 'WidgetTwinTableOptionsEditor',
  components: {
    NestedDashboardOptionsEditor,
    TwinAttributesSelector
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    customParameters: {
      type: Object,
      required: true
    },
    dashboardId: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    rowsPerPage: {
      get() {
        return get(this.editedWidget, 'twinTableOptions.rowsPerPage', 10);
      },
      set(val) {
        if (!val || val < 1) {
          val = 1;
        }
        this.setOptionsProperty('rowsPerPage', val);
      }
    },
    nestedDashboardConfig: {
      get() {
        return get(this.value, 'nestedDashboard', {}) || {};
      },
      set(val) {
        const clone = cloneDeep(this.value);
        set(clone, 'nestedDashboard', val);
        this.editedWidget = clone;
      }
    },
    editedWidget: {
      get() {
        const clone = cloneDeep(this.value);
        if (!clone.twinTableOptions) {
          clone.twinTableOptions = {
            columns: []
          };
        }
        if (!clone.twinTableOptions.columns) {
          clone.twinTableOptions.columns = [];
        }
        return clone;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    selectedColumns: {
      get() {
        return get(this.editedWidget, 'twinTableOptions.columns', []);
      },
      set(newColumns) {
        const clone = cloneDeep(this.editedWidget);
        clone.twinTableOptions.columns = newColumns;
        this.editedWidget = clone;
      }
    },
    twins() {
      return get(this.data, 'twin-table', []);
    },
    entityFilters() {
      return {
        twinFilter: get(this.value, 'twinFilter', {}),
        virtualDeviceFilter: get(this.value, 'virtualDeviceFilter', {})
      };
    }
  },
  methods: {
    setOptionsProperty(key, value) {
      const clone = cloneDeep(this.editedWidget);
      set(clone.twinTableOptions, key, value);
      this.editedWidget = clone;
    },
    isSortableColumn(columnIndex) {
      const property = get(this.editedWidget, `twinTableOptions.columns[${columnIndex}].property`, '');
      return isServerSortableProperty(property);
    },
    sortIcon(columnIndex) {
      if (!this.isSortableColumn(columnIndex)) {
        return null;
      }
      const sortOrder = get(this.editedWidget, `twinTableOptions.columns[${columnIndex}].sortOrder`);
      // match the arrow the rendered table header shows: Vuetify's `sort` icon is an up-arrow
      // for ascending and rotates it 180deg for descending
      if (sortOrder === 'asc') {
        return 'fal fa-sort-up';
      }
      if (sortOrder === 'desc') {
        return 'fal fa-sort-down';
      }
      if (sortOrder === 'disabled') {
        return 'fal fa-ban';
      }
      return 'fal fa-sort';
    },
    toggleSort(columnIndex) {
      if (!this.isSortableColumn(columnIndex)) {
        return;
      }
      const clone = cloneDeep(this.editedWidget);
      const sortOrder = get(clone, `twinTableOptions.columns[${columnIndex}].sortOrder`);
      if (!sortOrder) {
        set(clone, `twinTableOptions.columns[${columnIndex}].sortOrder`, 'asc');
      }
      if (sortOrder === 'asc') {
        set(clone, `twinTableOptions.columns[${columnIndex}].sortOrder`, 'desc');
      }
      if (sortOrder === 'desc') {
        set(clone, `twinTableOptions.columns[${columnIndex}].sortOrder`, 'disabled');
      }
      if (sortOrder === 'disabled') {
        set(clone, `twinTableOptions.columns[${columnIndex}].sortOrder`, '');
      }
      this.editedWidget = clone;
    }
  }
};